export const getRouteHome = () => "/";
export const getRouteProfile = () => "/profile";
export const getRouteLogin = () => "/login";
export const getRouteSignUp = () => "/signup";
export const getRouteSupport = () => "/support";
export const getRouteInviteFriend = () => "/invite-friend";
export const getRouteCreateReading = (psychicId?: string | number, skipChooseAdvisor = false) => {
  const searchParams = new URLSearchParams();

  if (psychicId) {
    searchParams.set("psychic", String(psychicId));
  }

  if (skipChooseAdvisor) {
    searchParams.set("skipChooseAdvisor", "Yes");
  }

  const queryString = searchParams.toString();

  return queryString ? `/create?${queryString}` : "/create";
};
export const getRouteReadingDetails = (id: string) => `/${id}`;
export const getRouteManageUsers = () => "/manage/users";
export const getRouteManageUserDetails = (id: string) => `/manage/users/${id}`;
export const getRouteManageReadings = () => "/readings";
export const getRouteManageReadingDetails = (id: string) => `/readings?request=${id}`;
export const getRouteManageArchivedReadings = () => "/archived-readings";
export const getRouteInactiveSubscription = () => "/inactive-subscription";
export const getRouteResetPassword = () => "/forgot_password";
export const getRouteSetNewPassword = () => "/forgot_password/confirm";
export const getRouteCreateProfile = () => "/create-profile";
export const getRouteAccount = () => "/account";
export const getRouteAccountPayment = () => "/account/payment";
export const getRouteAccountSubscription = () => "/account/subscription";
export const getRouteChooseAdvisor = () => "/account/choose-advisor";
export const getRouteAccountChangePassword = () => "/account/change-password";
export const getRouteManageGrades = () => "/manage/grades";
export const getRouteManageTags = () => "/manage/tags";
export const getRouteManageWriters = () => "/manage/writers";
export const getRouteWriterProfile = () => "/writer/profile";
export const getRouteForbidden = () => "/forbidden";

// customer endpoints
export const getRoutePsychics = () => "/my/psychics";
export const getRoutePsychicDetails = (id: string) => `/psychic/${id}`;
